export const getLineHeight = (node) => {
    const { lineHeight: nodeLineHeight, fontSize } = getComputedStyle(node);
    const lineHeight = parseFloat(nodeLineHeight);

    if (!isNaN(lineHeight)) {
        return lineHeight;
    }

    if (nodeLineHeight === 'normal') {
        return parseFloat(fontSize) * 120 / 100;
    }
};

export const getComputedHeight = (node) => {
    const { height } = getComputedStyle(node);

    return height;
};
